/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { colorClassNames } from '../../styles/Colors';

const IconShareAndroid = (props) => (
  <svg height="56px" width="56px" viewBox="0 0 56 56">
    <g transform="translate(-1 316)">
      <mask id="icon-shareandroid-b">
        <use fill="#fff" transform="translate(32 -297)" xlinkHref="#icon-shareandroid-a" />
      </mask>
      <g mask="url(#icon-shareandroid-b)">
        <use className={colorClassNames.fill(props.color)} transform="translate(32 -297)" xlinkHref="#icon-shareandroid-c" />
      </g>
    </g>
    <g transform="translate(-1 316)">
      <mask id="icon-shareandroid-d">
        <use fill="#fff" transform="translate(19 -291)" xlinkHref="#icon-shareandroid-a" />
      </mask>
      <g mask="url(#icon-shareandroid-d)">
        <use className={colorClassNames.fill(props.color)} transform="translate(19 -291)" xlinkHref="#icon-shareandroid-c" />
      </g>
    </g>
    <g transform="translate(-1 316)">
      <mask id="icon-shareandroid-e">
        <use fill="#fff" transform="translate(32 -285)" xlinkHref="#icon-shareandroid-a" />
      </mask>
      <g mask="url(#icon-shareandroid-e)">
        <use className={colorClassNames.fill(props.color)} transform="translate(32 -285)" xlinkHref="#icon-shareandroid-c" />
      </g>
    </g>
    <use className={colorClassNames.fill(props.color)} transform="translate(23.5 23)" xlinkHref="#icon-shareandroid-f" />
    <defs>
      <path id="icon-shareandroid-a" d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
      <path id="icon-shareandroid-c" d="M5 3a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4H5zM3 5a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4V5zM1 3a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4h2zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4v2z" />
      <path id="icon-shareandroid-f" d="M8.2 9.542l-8-3.5-.4.916 8 3.5.4-.916zm-8-5.584l8-3.5-.4-.916-8 3.5.4.916z" />
    </defs>
  </svg>
);
IconShareAndroid.propTypes = {
  color: colorClassNames.nameProp,
};
IconShareAndroid.defaultProps = {
  color: 'black',
};

export default IconShareAndroid;
